/* eslint-disable react/prop-types */
import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Steps } from 'antd';
import Container from '@components/shared/Admin/Container';
import { isEmpty } from 'lodash/fp';
import Spinner from '@components/shared/Spinner';
import routes from '@root/routes';
import api from '@shared/api';
import { matchType } from '@propTypes';
import PropertyForm from './PropertyForm';
import ExistingBuildingSuggestions from './ExistingBuildingSuggestions';
import s from './PropertyPage.module.css';
import translatedSteps from '../PropertySearch/propertySearchSteps';

class PropertyPage extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    match: matchType.isRequired,
  };

  state = {
    property: null,
    nearbyBuildings: [],
  };

  componentDidMount() {
    this.fetchProperty();
  }

  fetchProperty = async () => {
    const { match } = this.props;
    const {
      params: { id: propertyId },
    } = match;

    const response = await api.fetch(routes.api.admin.properties(propertyId));
    if (response.ok) {
      const property = await response.json();
      this.setState({ property }, () => {
        if (property.geolocationPrecision === 'building') {
          this.fetchNearbyBuildings();
        }
      });
    }
  };

  fetchNearbyBuildings = async () => {
    const { property } = this.state;
    const response = await api.fetch(
      routes.api.admin.buildingSearch({
        latitude: property.latitude,
        longitude: property.longitude,
        distance: 50,
      }),
    );

    if (response.ok) {
      const nearbyBuildings = await response.json();
      this.setState({ nearbyBuildings: nearbyBuildings.buildings });
    }
  };

  render() {
    const { t } = this.props;
    const { property, nearbyBuildings } = this.state;

    return (
      <>
        <Steps current={1}>
          {translatedSteps(t).map(({ title, description }) => (
            <Steps.Step key={title} title={title} description={description} />
          ))}
        </Steps>
        <Container>
          {property ? (
            <div>
              <PropertyForm property={property} />
              {!isEmpty(nearbyBuildings) ? (
                <>
                  <div className={s['existing-building-suggestions-help']}>
                    {t('building.existingBuildingsSuggestionsHelp')}
                  </div>
                  <ExistingBuildingSuggestions property={property} buildings={nearbyBuildings} />
                </>
              ) : null}
            </div>
          ) : (
            <div className={s['spinner-wrapper']}>
              <Spinner />
            </div>
          )}
        </Container>
      </>
    );
  }
}

export default withTranslation('admin')(PropertyPage);
